const hogsmeadeQuizQuestions = [
  {
    question: "Where in Hogwarts does the Honeydukes cellar lead to?",
    answers: [
      { answer: "The Gryffindor common room ", isCorrect: false },
      { answer: "The Kitchen", isCorrect: false },
      { answer: "The Great Hall", isCorrect: false },
      { answer: "Third-floor corridor", isCorrect: true }
    ]
  },
  {
    question: "Who is the sibling of the person who owns the Hogs Head Inn?",
    answers: [
      { answer: "Minerva McGonagall", isCorrect: false },
      { answer: "Albus Dumbledore", isCorrect: true },
      { answer: "Sybill Trelawney ", isCorrect: false },
      { answer: "Cuthbert Binns", isCorrect: false }
    ]
  },
  {
    question: "Usually, how many secret passages are there from Hogwarts to Hogsmeade?",
    answers: [
      { answer: "7", isCorrect: true },
      { answer: "11", isCorrect: false },
      { answer: "9", isCorrect: false },
      { answer: "13", isCorrect: false },
    ]
  },
  {
    question: "When does it snow in Hogsmeade?",
    answers: [
      { answer: "Only in winter", isCorrect: false },
      { answer: "During fall and winter", isCorrect: false },
      { answer: "Every day", isCorrect: true },
      { answer: "Randomly", isCorrect: false }
    ]
  },
  {
    question: "Which of the following is NOT a shop in Hogsmeade?",
    answers: [
      { answer: "Ollivanders Wand Shop", isCorrect: false },
      { answer: "Honeydukes", isCorrect: false },
      { answer: "The Three Broomsticks", isCorrect: false },
      { answer: "Madam Malkin's Robes for all Occasions", isCorrect: true }
    ]
  },

]

export default hogsmeadeQuizQuestions
